export const AdminDiagramStyle = {
  mainWrapper: {
    backgroundColor: '#f0f0f0',
    borderRadius: '8px',
    background: 'var(--default-white)',
    padding: '24px',
    marginTop: '16px',
    boxShadow: 'var(--box-shadow--1)',
  },
  income: {fontSize: '20px', fontWeight: '700'},
  tabWrapper: {display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingLeft: '24px', mb: '12px'},
  container: {padding: '24px', borderRadius: '8px', background: 'var(--default-white)'},
  wrapper: {
    width: '100%',
    margin: '0 auto',
    marginBottom: '24px',
  },

  tabs: {
    width: '50%',
    background: 'var(--default-white)',
    padding: '24px 0',
    maxHeight: '36px',
    borderRadius: '8px 8px 0 0',
  },

  tab: {
    width: '33%',
    zIndex: 99,
  },
};
